// angular import
import { Component, output } from '@angular/core';

// project import
import { FriendsList } from 'src/app/fack-db/friends-list';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { FriendComponent } from './friend/friend.component';
import { DataFilterPipe } from 'src/app/theme/shared/filter/data-filter.pipe';
import { ScrollbarComponent } from 'src/app/theme/shared/components/scrollbar/scrollbar.component';

interface friendsList {
  id: number;
  photo: string;
  name: string;
  new?: number;
  status: number;
  time: string;
}

@Component({
  selector: 'app-chat-user-list',
  imports: [SharedModule, FriendComponent, DataFilterPipe, ScrollbarComponent],
  templateUrl: './chat-user-list.component.html',
  styleUrls: ['./chat-user-list.component.scss']
})
export class ChatUserListComponent {
  ChatCollapse = output();
  ChatToggle = output<number>();
  friendsList: friendsList[];
  searchFriends!: string;

  constructor() {
    this.friendsList = FriendsList;
  }

  handleChatOn(friendId: number) {
    this.ChatToggle.emit(friendId);
  }
}
